import { render, staticRenderFns } from "./PostStatus.vue?vue&type=template&id=2cfa852f&"
import script from "./PostStatus.vue?vue&type=script&lang=js&"
export * from "./PostStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports